import { SelectOutlined } from "@nova/component-select"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"
import { useAppSelector } from "integrations/redux/hooks"
import { FunctionComponent, useMemo } from "react"

interface PilotPickerProps {
    value: string
    onChange: (userId: string) => void
    placeholder?: string
    disabled?: boolean
    label?: string
}

export const PilotPicker: FunctionComponent<PilotPickerProps> = ({
    value,
    onChange,
    placeholder = "Select pilot",
    disabled,
    label,
}) => {
    const members = useAppSelector(selectWorkspaceMembers)

    const options = useMemo(
        () =>
            (members ?? []).map((m) => ({
                label: m.fullName ?? m.userId,
                value: m.userId,
            })),
        [members]
    )

    return (
        <div className="flex flex-col gap-2 w-full">
            {label && <label className="text-gray-100">{label}</label>}
            <SelectOutlined<string>
                options={options}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                searchable
                className="w-full"
            />
        </div>
    )
}
